
import App from "@/components/pages/agent.vue";
import store from "@/store";
import Config from "@/config";
import Storage from "@/utils/storage";
import { getQueryValue, addToken } from "@/utils/index";
import {  Container,  Header,  Dropdown,  DropdownMenu,  DropdownItem,  Form,  FormItem,  Button,  Input,  Select,  Option,  OptionGroup,  DatePicker,  Divider,  Pagination,} from "apower-ui";
import "@/styles/pages/agent.scss";
import "@/styles/components/account-modal.scss";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            


const components = [
  Container,
  Header,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Form,
  FormItem,
  Button,
  Input,
  Select,
  Option,
  OptionGroup,
  DatePicker,
  Divider,
  Pagination,
];

components.forEach((component) => {
  Vue.component(component.name, component);
});

(async function () {
  // 同步登陆状态
  const userInfo = Storage.get("userInfo");
  const identityToken = Storage.get("identityToken");
  const apiToken = Storage.get("apiToken");
  if (userInfo && identityToken && apiToken) {
    store.dispatch("SyncLoginState", {
      api_token: apiToken,
      identity_token: identityToken,
      user: userInfo,
    });
  }

  // 获取Appid
  await store.dispatch("getAppId", Config.myaccountAppName);

  // 获取地区码
  await store.dispatch("getAreaCodes");

  // 处理第三方登录回调
  const state = getQueryValue("state");
  const action = getQueryValue("action");
  if (action === "login" && state) {
    store
      .dispatch("LoginByState", state)
      .then(() => {
        const returnUrl = Storage.get("returnUrl");
        const identityToken = Storage.get("identityToken");
        if (returnUrl) {
          window.location.href = addToken(
            decodeURIComponent(returnUrl),
            identityToken
          ).toString();
        } else {
          window.location.href = addToken(
            window.location.origin,
            identityToken
          ).toString();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();

new Vue({
  el: "#app",
  components: { App },
  render: (h) => h(App),
}).$mount("#app");

          })
        